// Provider Leadership Action Types - start
export const FETCH_RAD_LEADERSHIP_REQUEST = 'FETCH_RAD_LEADERSHIP_REQUEST';
export const FETCH_RAD_LEADERSHIP_SUCCESS = 'FETCH_RAD_LEADERSHIP_SUCCESS';
export const FETCH_RAD_LEADERSHIP_FAILURE = 'FETCH_RAD_LEADERSHIP_FAILURE';
 
export const RAD_LEADERSHIP_BULK_UPDATE_REQUEST = 'RAD_LEADERSHIP_BULK_UPDATE_REQUEST';
export const RAD_LEADERSHIP_BULK_UPDATE_SUCCESS = 'RAD_LEADERSHIP_BULK_UPDATE_SUCCESS';
export const RAD_LEADERSHIP_BULK_UPDATE_FAILURE = 'RAD_LEADERSHIP_BULK_UPDATE_FAILURE';
 
export const CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST = 'CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST';
export const CHECK_RAD_LEADERSHIP_EDIT_ACCESS_SUCCESS = 'CHECK_RAD_LEADERSHIP_EDIT_ACCESS_SUCCESS';
export const CHECK_RAD_LEADERSHIP_EDIT_ACCESS_FAILURE = 'CHECK_RAD_LEADERSHIP_EDIT_ACCESS_FAILURE';
 
export const DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST = 'DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST';
export const DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_SUCCESS = 'DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_SUCCESS';
export const DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_FAILURE = 'DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_FAILURE';
 
export const RESET_RAD_LEADERSHIP_EDIT_ACCESS = 'RESET_RAD_LEADERSHIP_EDIT_ACCESS';